import React from 'react';
import { inject, observer } from 'mobx-react';
import toNumber from 'lodash/toNumber';

const store = [
  'initStore'
]
@inject(...store)
@observer
class NavTop extends React.Component {

  render(){
    const { datas = [], pathname = '', onClick, onMouseOver, onMouseOut} = this.props;
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    const passAuth = me && me.com !== '' && me.com !== 'other';
    const isAdmin = me.role === "admin";
    const r_id = me.member ? me.member.r_id : '0';
    return (
      <div className='nav-top'
           onMouseOver={() => typeof onMouseOver === 'function' && onMouseOver()}
           onMouseOut={() => typeof onMouseOut === 'function' && onMouseOut()}>
        {
          datas.map(item => {
            let show = true;
            if (item.needAuth) {
              if (item.open === 'admin') show = isAdmin;
              else if (item.key === 'ecode') show = toNumber(r_id) >= 70;
              else show = passAuth;
            }
            return show ? (
              <span key={item.key}
                    className={`nav-top-item ${item.pathname === pathname && 'nav-top-item-active'}`}
                    onClick={() => typeof onClick === 'function' && onClick(item.pathname, item)}>
                    <i className={`nav-top-item-icon ${item.icon}`}/>
                    <span className={`nav-top-item-name ${item.pathname === pathname && 'nav-top-item-name-active'}`}>{item.name}</span>
              </span>
            ) : null
          })
        }
      </div>
    )
  }
}

export default NavTop;


// WEBPACK FOOTER //
// ./src/components/home/NavTop.js